<template>
  <div class="login-register">
    <el-card class="login-register--container">
      <div class="logo">
        <img src="assets/logo.svg" alt="WorkoutAP Logo">
      </div>

      <label v-if="!forgotPassView" class="login-title">{{ loginView ? 'Login' : 'Register' }}</label>
      <template v-if="forgotPassView">
        <el-button style="margin-bottom: 16px;" @click="toggleLoginReg" size="mini" icon="el-icon-back" round>Back to login</el-button>
        <label class="login-title">Forgot Password?</label>
      </template>

      <template v-if='loginView'>
        <form v-if="honeypot === ''" id="loginForm" @submit.prevent='Login'>
          <input tabindex="-1" @input="redirect()" type="text" v-model='honeypot' placeholder="Username" />
          <input type="email" v-model='email' placeholder="Email" />
          <input type="password" v-model='password' placeholder="Password" />
          <el-button round :disabled='loginBtnDisabled' form="loginForm" type="primary" native-type="submit">Login</el-button>
          <el-link type="primary" @click="showForgotPass" class="forgot-pass">Forgot Password?</el-link>
        </form>
      </template>
      
      <template v-if='forgotPassView'>
        <form v-if="honeypot === ''" id="forgotPassForm" @submit.prevent='forgotPassword'>
          <input tabindex="-1" @input="redirect()" type="text" v-model='honeypot' placeholder="Username" />
          <input type="email" v-model='resetEmail' placeholder="Email" />
          <el-button round :disabled='passResetBtnDisabled' form="forgotPassForm" type="primary" native-type="submit">Send reset password email</el-button>
        </form>
      </template>

      <template v-if='registerView'>
        <form v-if="honeypot === ''" id="registerForm" @submit.prevent='Register'>
          <input tabindex="-1" @input="redirect()" type="text" v-model='honeypot' placeholder="Username" />
          <input type="email" v-model='regEmail' placeholder="Email" />
          <input type="password" v-model='regPassword' placeholder="Password" @input="judgePass" />
          <div v-if="judgePassword === false" class="pass-check">
            <div v-if="!lengthCheck">Password must be at least 8 characters.</div>
            <div v-if="!numberCheck">Password must contain at least one number.</div>
            <div v-if="!capitalCheck">Password must contain at least one capital letter.</div>
            <div v-if="!specialCheck">Password must contain at least one special character.</div>
          </div>
          <input :disabled='judgePassword' type="password" v-model='confirmPassword' placeholder="Confirm password" @input="(confirmPassword !== regPassword && confirmPassword !== '') ? matchCheck = false : matchCheck = true" />
          <div v-if="matchCheck === false" class="pass-check">
            <div>Confirm Password does not match New Password.</div>
          </div>
          <div style="margin-bottom: 16px;">
            <label>Are you a Trainer</label>
            <el-radio v-model="isTrainer" :label="true">Yes</el-radio>
            <el-radio v-model="isTrainer" :label="false">No</el-radio>
          </div>
          <el-button round :disabled='regBtnDisabled' form="registerForm" type="primary" native-type="submit">Register</el-button>
        </form>
      </template>

      <hr v-if="!forgotPassView">
      <p v-if="!forgotPassView">{{ loginView ? 'Need an account?' : 'Have an account?' }}</p>
      <el-button v-if="!forgotPassView" round @click='toggleLoginReg'>{{ loginView ? 'Register here' : 'Login here' }}</el-button>
      <template v-if="honeypot !== ''">
        <p>Nice try, bot.</p>
      </template>
    </el-card>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  data () {
    return {
      resetEmail: '',
      email: '',
      password: '',
      regEmail: '',
      regPassword: '',
      confirmPassword: '',
      honeypot: '',
      loginView: true,
      registerView: false,
      isTrainer: '',
      numberCheck: true,
      lengthCheck: true,
      capitalCheck: true,
      specialCheck: true,
      judgePassword: true,
      matchCheck: true,
      forgotPassView: false 
    }
  },
  methods: {
    showForgotPass() {
      this.loginView = false
      this.registerView = false
      this.forgotPassView = !this.forgotPassView
    },
    toggleLoginReg() {
      if (this.forgotPassView) {
        this.forgotPassView = !this.forgotPassView
        this.loginView = !this.loginView
      } else {
        this.loginView = !this.loginView
        this.registerView = !this.registerView
      }
    },
    Login() {
      if (this.honeypot === '') {
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(data => {
          console.log(data)
          this.$emit('login')
        }).catch(err => alert(err.message))
      }
    },
    forgotPassword() {
      firebase.auth().sendPasswordResetEmail(this.resetEmail, {url: 'https://app.workoutap.com'}).then(() => {
        this.$message({
          message: 'If ' + this.resetEmail + ' is associated with an account, then a reset password email was sent.',
          type: 'success'
        })
        this.toggleLoginReg()
        this.resetEmail = ''
      }).catch(err => err.message)
    },
    Register() {
      if (this.regPassword === this.confirmPassword) {
        if (this.honeypot === '') {
          firebase.auth().createUserWithEmailAndPassword(this.regEmail, this.regPassword).then(user => {
            
            firebase.database().ref().child(user.user.uid).set({
              'isTrainer': this.isTrainer
            })

            this.$emit('newRegister')

          }).catch(err => alert(err.message))
        }
      } else {
        this.$message({
          message: 'Passwords do not match',
          type: 'error'
        })
      }
    },
    redirect() {
      window.location.href = 'https://www.google.com'
    },
    judgePass() {
      if (!(this.regPassword.length > 7) ||
      !/\d/.test(this.regPassword) ||
      this.regPassword == this.regPassword.toLowerCase() ||
      !/[\s~`!@#$%^&*+=\-[\]\\';,/{}|\\":<>?()._]/g.test(this.regPassword)) {
        this.judgePassword = false
      }
      
      if (this.regPassword == '') {
        this.judgePassword = true
      }

      // Length check
      this.regPassword !== '' && !(this.regPassword.length > 7) ?
        this.lengthCheck = false :
        this.lengthCheck = true
      // Number check
      this.regPassword !== '' && !/\d/.test(this.regPassword) ?
        this.numberCheck = false :
        this.numberCheck = true
      // Capital Letter check
      this.regPassword !== '' && this.regPassword == this.regPassword.toLowerCase() ?
        this.capitalCheck = false :
        this.capitalCheck = true
      // Special Character check
      this.regPassword !== '' && !/[\s~`!@#$%^&*+=\-[\]\\';,/{}|\\":<>?()._]/g.test(this.regPassword) ?
        this.specialCheck = false :
        this.specialCheck = true
    }
  },
  computed: {
    passResetBtnDisabled: function() {
      if (!/.com/.test(this.resetEmail) ||
      !/@/.test(this.resetEmail)) {
        return true
      } else {
        return false
      }
    },
    regBtnDisabled: function() {
      if (this.regEmail == '' ||
      this.isTrainer === '' ||
      !(this.regPassword.length > 7) ||
      !(this.confirmPassword.length > 7) ||
      !/\d/.test(this.regPassword) ||
      !/\d/.test(this.confirmPassword) ||
      this.regPassword == this.regPassword.toLowerCase() ||
      this.confirmPassword == this.confirmPassword.toLowerCase() ||
      !/[\s~`!@#$%^&*+=\-[\]\\';,/{}|\\":<>?()._]/g.test(this.regPassword) ||
      !/[\s~`!@#$%^&*+=\-[\]\\';,/{}|\\":<>?()._]/g.test(this.confirmPassword)) {
        return true
      } else {
        return false
      }
    },
    loginBtnDisabled: function() {
      if (this.email == '' ||
      this.password == '') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style>
#registerForm > input:first-child,
#loginForm > input:first-child,
#forgotPassForm > input:first-child {
  display: none;
}

.login-register {
  align-items: center;
  background: linear-gradient(0deg, #e020aa, #e47ec7);
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  position: fixed;
  width: 100%;
}

.login-register .logo {
  width: 258px;
  margin-bottom: 16px;
}

.login-register .login-register--container {
  max-width: 300px;
}

.login-register .login-register--container .login-title {
  margin-bottom: 8px;
}

.pass-check {
  color: red;
  font-size: 12px;
}

.pass-check div:last-child {
  margin-bottom: 16px;
}

.el-link.forgot-pass {
  margin-left: 12px;
}

@media (max-width: 991px) {
  .login-register {
    justify-content: flex-end;
  }

  .login-register .login-register--container {
    border: 0;
    border-radius: 32px 32px 0 0;
    box-shadow: none;
    max-width: 100%;
    padding: 8px 0 64px;
    width: 100%;
  }
}
</style>